import React from "react";

//////////////////////////////////////////////
//// NOT FOUND - REDIRECTING TO HOME PAGE ////
//////////////////////////////////////////////
export class NotFound extends React.Component {
  componentDidMount() {
    const {history} = this.props;
    if (history.location.pathname === "/") history.replace(`/`);
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/containers/NotFound.js